import { create } from 'zustand';

interface PermissionDeniedState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

/** 全局 403 状态；重复的并发失败只会维持同一个权限弹窗。 */
export const usePermissionDeniedStore = create<PermissionDeniedState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
